import ThreeDotsComponent from "./ThreeDotsComponent";

export default ThreeDotsComponent;
